import React from 'react';
import { Table, tr, td } from 'react-bootstrap';
import '../DataCollectionGroupPanel.css';
import {  convertToFixed } from '../../../../helpers/NumericTransformationsHelper.js';

export default class ThirdSectionPanel extends React.Component {  
    getRow(key, value){
            return  <tr>
                        <td  xs={5} md={5} className="parameterKey" >{key}</td>
                        <td  xs={7} md={7} className="parameterValue" >{value}</td>
                    </tr>;
    }       
         
    render() {                              
        return <Table>
                    <tbody>                     
                        {this.getRow("Beamline Name",  this.props.datacollectiongroup.beamlineName)}
                        {this.getRow("Detector Distance",  convertToFixed(this.props.datacollectiongroup.detectorDistance, 2) + " mm")}
                        {this.getRow("X Beam",  convertToFixed(this.props.datacollectiongroup.xBeam, 2) + " mm")}
                        {this.getRow("Y Beam",  convertToFixed(this.props.datacollectiongroup.yBeam, 2) + " mm")}
                        {this.getRow("Kappa",  this.props.datacollectiongroup.kappaStart)}
                        {this.getRow("Phi",  this.props.datacollectiongroup.phiStart)} 
                    </tbody>                     
            </Table>;
    }
}







// WEBPACK FOOTER //
// ./src/components/Mx/DataCollectionGroup/BeamlineDataCollectionGroup/ThirdSectionPanel.js